import { isLoadingType } from '../loading/selectors';
import { FETCH_CREDITS_REQUEST } from './actions';
export const getState = (state) => state.credits;
export const getData = (state) => getState(state).data;
export const getLoading = (state) => getState(state).loading;
export const getError = (state) => getState(state).error;
export const isFetchingCredits = (state) => isLoadingType(getLoading(state), FETCH_CREDITS_REQUEST);
export const getCredits = (state, address) => getData(state)[address];
//# sourceMappingURL=selectors.js.map